import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { IListingCardParams } from '../ListingCard/listing.card.params';
import { CommonConfig } from '../../configs/config.common';
import ListingCard from '../ListingCard/listing.card.vue';
import * as T_T from 'cryface';
import { UserInfoDelegate } from '../../services/DataDelegate/UserInfoDelegate/user.info.delegate';
import { AxiosPromise } from '../../utils/axios.promise';
import { TrinityRingsSpinner } from 'epic-spinners';

@Component({
   components: {
      ListingCard,
      TrinityRingsSpinner,
   }
})
export default class PropertyList extends Vue {
   public title: string = 'PropertyList';

   public data: IListingCardParams[] = [];

   public configs = new CommonConfig();

   public userInfoService = new UserInfoDelegate();

   public initiated = false;

   public isLoading = false;

   @Prop()
   public page: any;

   @Prop()
   public ltype: any;

   @Prop()
   public recommandType: any;

   @Prop()
   public setTotalPage: any;

   public created() {
   }

   public mounted() {
      if (!this.initiated) {
         // this.fetchAgentListings();
      }
   }

   @Watch('page', { immediate: true, deep: true })
   public async onPageChange(val: any, oldVal: any) {
      if (T_T.simpleDetect(val)) {
         this.page = val;
         await this.fetchAgentListings();
         this.scrollToTop();
      }
   }

   @Watch('$store.state.auth', { immediate: true, deep: true })
   public onAuthed(val: any, oldVal: any) {
      if (T_T.simpleDetect(val.userInfo.value.userId) && !this.initiated) {
         // console.log(this.initiated, 'this.initiated');
         this.fetchAgentListings(val.userInfo.value);
         this.initiated = true;
      }
   }

   public async fetchAgentListings(userInput: any = null) {
      const page = T_T.simpleDetect(this.page) ? this.page : 1;
      const ltype = T_T.simpleDetect(this.ltype) ? this.ltype : 1;
      const apiHost = this.configs.cmisapiHost;
      const user = userInput ? userInput : this.$store.state.auth.userInfo.value;
      if (T_T.simpleDetect(user.userId)) {
         this.isLoading = true;
         const dataFetched = await AxiosPromise.get(`${apiHost}/channel/channelHouseListByUserAttention?cimsUrefId=${user.userId}&pageNum=${page}&pageSize=6&ltype=${ltype}`);
         this.isLoading = false;
         const dataMapped: any[] = [];
         if (dataFetched.code === 200) {
            if (T_T.simpleDetect(dataFetched.data)) {
               dataFetched.data.map((v: any) => {
                  dataMapped.push(
                     {
                        id: v.identifier,
                        price: v.price,
                        type: v.listingType.toUpperCase(),
                        picture: v.picture,
                        address: v.full_address,
                        bedrooms: `${v.bedrooms}`,
                        bedroomPlus: `${v.bedrooms_plus}`,
                        bathrooms: `${v.washrooms}`,
                        garages: ``,
                        mlsNumber: `${v.mlsNumber}`,
                     }
                  );
               });
            }
            this.data = dataMapped;
            if (T_T.simpleDetect(this.setTotalPage)) {
               this.setTotalPage(dataFetched.totalPage, dataFetched.totalRecord, dataFetched.pageSize);
            }
         } else { }
      }
   }

   public scrollToTop() {
      window.scrollTo(0, 0);
   }
}
